import { cx, toDataAttrs } from '../lib/cx';

export default function Section({
  as: El = 'section',
  id,
  className,
  pin = false,
  data,
  children,
  ...rest
}) {
  const section = (
    <El id={id} className={cx('region', className)} {...toDataAttrs(data)} {...rest}>
      {children}
    </El>
  );

  if (!pin) {
    return section;
  }

  return (
    <div className="content-scroll-pin-wrap">
      <div className="fixx-placeholder" aria-hidden="true" />
      {section}
      <div className="content-scroll-pin-end" aria-hidden="true" />
    </div>
  );
}
